"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionIdConverter = void 0;
class CommissionIdConverter {
    static convertCommissionDataToId(commissionNumber, bid, commissionNumberYear) {
        if (!commissionNumber || !commissionNumberYear || !bid) {
            return undefined;
        }
        return `${commissionNumber}-${bid}-${commissionNumberYear}`;
    }
    static convertCommissionIdToData(commissionId) {
        const splits = commissionId === null || commissionId === void 0 ? void 0 : commissionId.split('-');
        if (!splits || splits.length !== 3 || !(splits[0] && splits[1] && splits[2])) {
            return undefined;
        }
        return {
            commissionNumber: splits[0],
            bid: splits[1],
            commissionNumberYear: splits[2]
        };
    }
}
exports.CommissionIdConverter = CommissionIdConverter;
//# sourceMappingURL=CommissionIdConverter.js.map